import { Component, input, ChangeDetectionStrategy, ViewEncapsulation } from "@angular/core";
import { CommonModule } from "@angular/common";
import { cn } from "../utils/utils";

@Component({
  selector: "agent-chat-view-feather",
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  template: `<div [class]="computedClass" [style]="style()"></div>`,
})
export class AgentChatViewFeather {
  inputClass = input<string | undefined>();

  style = input<{ [key: string]: any } | undefined>();

  get computedClass(): string {
    return cn("achat-feather", this.inputClass());
  }
}
